import {yupResolver} from "@hookform/resolvers/yup";

import {StatusPage} from "@/lib/types/statuspages.ts";
import {SharedStatusPageFormData, SharedStatusPageFormKeys} from "@/pages/statuspages/shared/StatusPage.types.ts";
import {mergeSchemas} from "@/pages/statuspages/statuspages-create/CreateStatusPageForm.utils.tsx";
import {StatusPageDesignTabSchema} from "@/pages/statuspages/tabs/design/StatusPageDesignTab.form.ts";
import {StatusPageGeneralSchema} from "@/pages/statuspages/tabs/general/StatusPageGeneralTab.form.ts";
import {SubscribersSettingsFormSchema} from "@/pages/statuspages/tabs/subscribers/components/SubscribersSettingsForm/SubscribersSettingsForm.form.ts";

export const generateStatusPageDefaultValues = (statusPage: StatusPage): Partial<SharedStatusPageFormData> => {
  // maps preview strings to the actual form fields to prevent needing to pass in separately and handle two different values
  const mapToFormData: Partial<Record<SharedStatusPageFormKeys, string>> = {
    logo: statusPage.logo_url,
    favicon: statusPage.favicon_url,
    email_logo: statusPage.email_logo_url,
  };

  const defaultsFromStatusPage = Object.fromEntries(
    (SharedStatusPageFormKeys as unknown as string[]).map((key) => [
      key,
      statusPage[key as keyof typeof statusPage] === undefined ? undefined : statusPage[key as keyof typeof statusPage],
    ])
  ) as Partial<SharedStatusPageFormData>;

  return {
    ...defaultsFromStatusPage,
    ...mapToFormData,
    password_protection_enabled: !!(statusPage.auth_username || statusPage.auth_password),
  } as Partial<SharedStatusPageFormData>;
};

export const UpdateStatusPageYupResolver = yupResolver(
  mergeSchemas<SharedStatusPageFormData>(
    StatusPageGeneralSchema,
    StatusPageDesignTabSchema,
    SubscribersSettingsFormSchema
  )
);
